import { ccv, crv, cva } from '@/styled-system/css';

export const anchorRecipe = cva({
  base: {
    textDecoration: {
      base: 'Anchor.default',
    },
    textStyle: 'inherit',
    color: {
      base: 'Anchor.default',
    },
    focusOutline: true,
  },
  variants: {
    disabled: {
      true: {
        cursor: 'default',
        opacity: 'disabled',
      },
      false: {
        color: {
          _hover: 'Anchor.hover',
          _active: 'Anchor.pressed',
          _focusVisible: 'Anchor.focus',
          _visited: 'Anchor.visited',
        },
        cursor: 'pointer',
      },
    },
    ...crv('onImpact', {
      true: {
        color: {
          base: 'Anchor.onImpact.default',
        },
        textDecoration: {
          _hover: 'Anchor.hover',
        },
      },
      false: {},
    }),
  },
  compoundVariants: [
    ...ccv({
      onImpact: true,
      disabled: false,
      css: {
        color: {
          _hover: 'Anchor.onImpact.hover',
          _active: 'Anchor.onImpact.pressed',
          _focusVisible: 'Anchor.onImpact.focus',
          _visited: 'Anchor.onImpact.visited',
        },
      },
    }),
  ],
});
